import React from 'react'
import {Button} from './Button';
// import Spinner from 'react-bootstrap';

export const NewButton = (props) => {
  return (
    <Button 
      {...props}
      label={props.label}
      icon={props.icon} 
      className={'btn-fill pull-right '+props.className}
      disabled={props.disabled ? true : false}
      variant={props.variant? props.variant : 'info'}
    >{props.label}</Button>
  )
}
